import "./SearchProductSiat.css";

const SearchProductSiat = ({ search, setSearch }) => {
  return (
    <input
      className="searchProductSiat" 
      placeholder="Buscar"
      type="search"
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      style={{ backgroundColor: "whitesmoke" }}
    />
  );
};
export default SearchProductSiat